import * as ST from './styled';

interface IProps {
    sectionRef?: React.RefObject<HTMLDivElement>,
    title?: string,
    description?: string,
    children?: JSX.Element | JSX.Element[],
}

const PageSection = ({ sectionRef, title, description, children }: IProps): JSX.Element => {
    return (
        <ST.Block ref={sectionRef}>
            {title &&
                <ST.BlockInfo>
                    <ST.Title dangerouslySetInnerHTML={{ __html: title }}/>
                    {description &&
                        <ST.Text dangerouslySetInnerHTML={{ __html: description }}/>
                    }
                </ST.BlockInfo>
            }
            {children}
        </ST.Block>
    );
};

export default PageSection;
